/**
 * User: hella
 * Date: 4/6/14
 * Time: 11:50 AM
 * Copyright 1stdibs.com, Inc. 2014. All Rights Reserved.
 */

'use strict';

var root = typeof window === 'undefined' ? global : window;
var vendor = root.navigator ? root.navigator.vendor : undefined;
var getIeDocumentMode;
var browserCheck;

getIeDocumentMode = function () {
    return root.document ? root.document.documentMode : undefined;
};

/**
 * Browser check since jQuery 1.9.x removes jQuery.browser
 * Some resources:
 * http://stackoverflow.com/questions/9847580/how-to-detect-safari-chrome-ie-firefox-and-opera-browser
 * this checks for chrome:
 * http://stackoverflow.com/a/13348618/339698
 *
 * formerly:
 * js/global/core/dibs.js#browser
 * dibs.browser
 *
 * @module browserCheck
 */
browserCheck = module.exports = {
    /**
     * @returns {boolean}
     */
    chrome: function () {
        return !!root.chrome && vendor === 'Google Inc.' && !this.opera();
    },
    /**
     * @returns {boolean}
     */
    ie: function () {
        // global.document.body.style.msTextCombineHorizontal: 11+ (http://stackoverflow.com/questions/18907131/detecting-ie11-using-css-properties)
        // global.document.documentMode: 7-10
        return this.ie11() || (root.document ? !!root.document.documentMode : undefined);  //  formerly !!getIeDocumentMode()
    },
    /**
     * @returns {boolean}
     */
    ie8: function () {
        return this.ie() && getIeDocumentMode() === 8;
    },
    /**
     * @returns {boolean}
     */
    ie9: function () {
        return this.ie() && getIeDocumentMode() === 9;
    },
    /**
     * @returns {boolean}
     */
    ie10: function () {
        return this.ie() && !!root.navigator.msPointerEnabled;
    },
    /**
     * @returns {boolean}
     */
    ie11: function () {
        return root.document ? (typeof root.document.body.style.msTextCombineHorizontal !== 'undefined') : undefined;
    },
    /**
     * @returns {boolean}
     */
    mozilla: function () {
        return typeof root.InstallTrigger !== 'undefined';
    },
    /**
     * opera is using Blink + V8 so it mimics chrome a lot, but still differentiates the User Agent
     * @returns {boolean}
     */
    opera: function () {
        return !!root.opera || (root.navigator.userAgent && root.navigator.userAgent.indexOf(' OPR/') >= 0);
    },
    /**
     * @returns {boolean}
     */
    safari: function () {
        return vendor === 'Apple Computer, Inc.' &&
            Object.prototype.toString.call(root.HTMLElement).indexOf('Constructor') > 0;
    },
    /**
     * @returns {boolean}
     */
    webKit: function () {
        return !!root.WebKitPoint;
    }
};

// added for parity in original core/dibs.js
/**
 * @see {@link browserCheck#ie8}
 * @type {Function}
 */
browserCheck.isIE8  = browserCheck.ie8;
/**
 * @see {@link browserCheck#ie9}
 * @type {Function}
 */
browserCheck.isIE9  = browserCheck.ie9;
/**
 * @see {@link browserCheck#ie10}
 * @type {Function}
 */
browserCheck.isIE10 = browserCheck.ie10;
/**
 * @see {@link browserCheck#ie11}
 * @type {Function}
 */
browserCheck.isIE11 = browserCheck.ie11;



//////////////////
// WEBPACK FOOTER
// ./~/bunsen/helpers/browserCheck.js
// module id = 478
// module chunks = 62